import { render, staticRenderFns } from "./CouponCard.vue?vue&type=template&id=72fbe640&scoped=true"
import script from "./CouponCard.vue?vue&type=script&lang=js"
export * from "./CouponCard.vue?vue&type=script&lang=js"
import style0 from "./CouponCard.scss?vue&type=style&index=0&id=72fbe640&prod&lang=scss&scoped=true&external"
import style1 from "./CouponCard.vue?vue&type=style&index=1&id=72fbe640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fbe640",
  null
  
)

export default component.exports